var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpotlightLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.1 21.2c0 .1-.1.1-.1.1l-.1.1H3.8c-.1 0-.2 0-.3-.1h-.2c0-.1-.1-.1-.1-.2h-.1v-.2H3v-9.5c0-.3.2-.5.4-.7.3-.1.6-.1.8.1L7 12.5l4.5-9.1c.2-.2.4-.4.7-.4.3 0 .6.2.7.4l8.4 16.9c.2.3.1.7-.2.9Z",
  opacity: 0.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m7 12.5-3.9 7.8c-.1.1-.1.2-.1.3v.1c0 .2.1.3.2.5.2.1.4.2.6.2h16.9c.1 0 .3 0 .4-.2L7 12.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotlightLogo);
export default ForwardRef;